export interface RequestGeoAddressParams {
  userId: number;
  date: string;
  type: "in" | "out";
}

// Shared by every screen that offers a "fetch address" action (Attendance
// Summary, Today's Attendance dashboard, …) so the endpoint contract and
// error handling live in exactly one place.
export async function requestGeoAddress({
  userId,
  date,
  type,
}: RequestGeoAddressParams): Promise<string> {
  const res = await fetch("/api/attendance/geo-address", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ userId, date, type: type.toUpperCase() }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error ?? "Failed to fetch address");
  return data.address as string;
}
